/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown>, detail: NonNullable<unknown> }} Workout_Set_LoggedInputs */

const en_us2_workout_set_logged = /** @type {(inputs: Workout_Set_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Set ${i?.n} logged · ${i?.detail}`)
};

const pt_br2_workout_set_logged = /** @type {(inputs: Workout_Set_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Série ${i?.n} registrada · ${i?.detail}`)
};

const es_419_workout_set_logged = /** @type {(inputs: Workout_Set_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serie ${i?.n} registrada · ${i?.detail}`)
};

const pt_pt2_workout_set_logged = /** @type {(inputs: Workout_Set_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Série ${i?.n} registada · ${i?.detail}`)
};

const fr_fr2_workout_set_logged = /** @type {(inputs: Workout_Set_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Série ${i?.n} enregistrée · ${i?.detail}`)
};

const de_de2_workout_set_logged = /** @type {(inputs: Workout_Set_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Satz ${i?.n} erfasst · ${i?.detail}`)
};

const it_it2_workout_set_logged = /** @type {(inputs: Workout_Set_LoggedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Serie ${i?.n} registrata · ${i?.detail}`)
};

/**
* | output |
* | --- |
* | "Set {n} logged · {detail}" |
*
* @param {Workout_Set_LoggedInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_set_logged = /** @type {((inputs: Workout_Set_LoggedInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Set_LoggedInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_set_logged(inputs)
	if (locale === "es-419") return es_419_workout_set_logged(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_set_logged(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_set_logged(inputs)
	if (locale === "de-DE") return de_de2_workout_set_logged(inputs)
	if (locale === "it-IT") return it_it2_workout_set_logged(inputs)
	return en_us2_workout_set_logged(inputs)
});
export { workout_set_logged as "workout.set_logged" }